/**
 * @generated SignedSource<<4cf98fbc9835e722c83161366231b13c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfoWrapper_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedCustomsMessage_item">;
  readonly " $fragmentType": "PdpSharedShippingInfoWrapper_item";
};
export type PdpSharedShippingInfoWrapper_item$key = {
  readonly " $data"?: PdpSharedShippingInfoWrapper_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoWrapper_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingInfoWrapper_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedCustomsMessage_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "44165ebbcfc2554cca23098793db4638";

export default node;
